<template>
<div class="userManage" v-if="update">
  <!--选择区-->
  <div class="topButton">
    <el-form ref="form" label-width="10px" class="dataForm"  v-loading="loading">
      <el-form-item v-for="(item,index) in form" :key="item.name" v-if="item.type !== 3" :prop="item.name">
        <!--<el-input v-if="item.type === 0" :name="item.name" v-model="item.value"  @change="changes(index)"  :placeholder="item.label" clearable></el-input>-->
        <el-select :name="item.name" v-model="item.value" @change="changes(index)" :placeholder="item.label" clearable  >
          <el-option v-for="it in item.options" :key="it.value" :label="it.label" :value="it.label"></el-option>
        </el-select>
        <i class="el-icon-delete-solid delDisplay" @click="delDisplay(index)" title="移除本项"></i>
      </el-form-item>
    </el-form>
    <!--弹窗显示-->
    <div class="data">
      <el-button :disabled="disable" @click="choose" icon="el-icon-plus" type="success"></el-button>
    </div>
    <!--重置选择-->
    <div class="reset">
      <el-button @click="resetting" type="warning">重置</el-button>
    </div>
    <div class="view">
      <el-button @click="view" type="warning">查看统计图</el-button>
    </div>
  </div>
  <!--数据展示-->
  <div class="mainTable1" ref="date">
    <!--表格组件-->
    <el-table ref="multipleTable" tooltip-effect="dark" border highlight-current-row :data="tableData.slice((pageInfo.currentPage-1)*pageInfo.pageSize,pageInfo.currentPage*pageInfo.pageSize)" :height="tableHeight" :max-height="tableHeight"
      :row-key="tableData.id" v-loading="load">
      <el-table-column v-for="(item) in tableTitle" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
      </el-table-column>
      <el-table-column label="操作"  width="160" align="center">
        <template slot-scope="scope">
          <el-button @click="lookCasenumber(scope.$index,scope.row)" size="mini" type="primary">该型案例编号</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页器-->
    <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="tableData.length" @size-change="handleSizeChange" :page-sizes="[5, 10, 20, 30]"
      @current-change="handleCurrentChange">
    </el-pagination>
    <!-- 编辑弹框---start -->
  </div>
  <!--弹框-->
  <dataDialog v-if="update"></dataDialog>
  <!--查看详情-->
  <UserManage></UserManage>
  <!--查看图表-->
  <viewChatrs></viewChatrs>
</div>
</template>

<script>
import dataDialog from "./dataDialog";
import UserManage from "./caseNumber";
import data1 from "../assets/javascript/findData";
import viewChatrs from "./viewChatrs";

import bus from './bus'

export default {
  inject: ['reload'],
  name: "系统数据统计",
  components: {
    viewChatrs,
    dataDialog,
    UserManage
  },
  data() {
    return {
      /*加载动画*/
      loading: false,
      load: false,
      /*表单渲染的数组*/
      form: [],
      /*两个01码*/
      fileCode: '',
      tableCode: '',
      /*是否可操作*/
      disable: false,
      /*刷新组件的值*/
      update: true,
      /*分页器的参数*/
      pageInfo: {
        currentPage: 1,
        pageSize: 10,
      },
      /*表格的最大高度*/
      tableHeight: '',
      /*表格组件渲染数组*/
      tableTitle: [{
          label: "案例所属类型",
          width: "",
          prop: "title",
          show: true
        },
        {
          label: "对应案例数量",
          width: "",
          prop: "countNumber",
          show: false
        },
        {
          label: "案例百分比",
          width: "",
          prop: "percentage",
          show: false
        },
      ],
      /*表格数据*/
      tableData: [],
    }
  },
  methods: {
    /*显示删除按钮*/
    delDisplay(index){
      // 当删除之前满足条件为三个选满且删除的是最后一个时，加号不禁用
      if (this.form.length === 3 && index === 2) {
        this.disable = false;
      }
      else if(this.form.length === 2 && index === 1) {
        this.disable = false;
      }
      // 当选择项只有一个时也放开加号的权限
      else if(this.form.length === 1){
        this.disable = false;
        this.tableData = [];
      }
      this.form.splice(index,1);
    },
    /*发送图表相关*/
    view (){
      bus.$emit("view",true)
    },
    /*下拉框的值改变时*/
    changes(index) {
      if (index === (this.form.length - 1) && this.form.length < 3) {
        this.disable = false;
      }
      if (this.form.length === 3 && index < 2) {
        this.getTable();
      }
      else if (this.form.length === 2 && index < 1) {
        this.getTable();
      }
    },
    /*查看案例编号*/
    lookCasenumber(index, row) {
      //分三种情况对需要的值进行封装
      let postData = {};
      let length = this.form.length;
      if (length === 1) {
        let key = this.form[0].name;
        postData[key] = row.title;
      }
      if (length === 2) {
        for (let i = 0; i < 1; i++) {
          let key = this.form[i].name;
          postData[key] = this.form[i].value;
        }
        let key = this.form[1].name;
        postData[key] = row.title;
      }
      if (length === 3) {
        for (let i = 0; i < 2; i++) {
          let key = this.form[i].name;
          postData[key] = this.form[i].value;
        }
        let key = this.form[2].name;
        postData[key] = row.title;
      }
      //调接口
      postData = JSON.stringify(postData);
      this.load = true;
      this.$http.post(
          '/statistics/grading/detail',
          postData, {
            headers: {
              'Content-Type': "application/json"
            }
          }
        )
        .then((res) => {
          bus.$emit('caseNumber', res);
          this.$nextTick(
            this.load = false,
          );
        })
        .catch((err) => {
          console.log(err);
          this.$nextTick(
            this.load = false,
          );
        });

    },
    // /*刷新弹窗的方法*/
    reloads() {
      this.update = false;
      // 在组件移除后，重新渲染组件
      this.update = true;
    },
    /*重置所有的选择项重新进行选择*/
    resetting() {
      this.disable = false;
      this.form = [];
      this.tableData = [];
      this.reloads();
    },
    /*弹窗方法*/
    choose() {
      bus.$emit('chooseData', true);
    },
    /* 分页大小切换*/
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
    },
    /*分页切换*/
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
    },
    /*获取高度*/
    getHeight() {
      /*定义两个高度，初始高度和现在高度*/
      let nowH;
      /*延迟获取当前高度*/
      this.$nextTick(() => {
        nowH = this.$refs.date.offsetHeight - 36;
      });
      let height = this.tableHeight;
      /*比对操作*/
      if (nowH !== height) {
        this.tableHeight = nowH;
        this.table++;
      }
    },
    /*获取表格数据*/
    getTable() {
      let postData = {};
      if (this.form.length === 2) {
        let key = this.form[0].name;
        postData[key] = this.form[0].value;
      }
      if (this.form.length === 3) {
        for (let i = 0; i < 2; i++) {
          let key = this.form[i].name;
          postData[key] = this.form[i].value;
        }
      }
      let filedCode = 'filedCode';
      let tableCode = 'tableCode';
      postData[filedCode] = this.filedCode;
      postData[tableCode] = this.tableCode;
      postData = JSON.stringify(postData);
      this.loading = true;
      this.$http.post(
          '/statistics/grading',
          postData, {
            headers: {
              'Content-Type': "application/json"
            }
          }
        ).then((res) => {
            //计算百分数
            let count = 0;
            let options = [];
            let row = [];
            let obj ={"title":'',"countNumber":0};
            for (let i = 0; i < res.length; i++) {
              count += res[i].countNumber;
            }
          for (let i = 0; i < res.length; i++) {
            row.push({'title':res[i].title,'案例数量':res[i].countNumber,"百分占比":(res[i].countNumber/count)*100})
          }
          /*将数据给VIEW*/
          bus.$emit('vData',row);
          for (let i = 0; i < res.length; i++) {
            let key = 'percentage';
            res[i][key] = Math.round(res[i].countNumber / count * 10000) / 100.00 + "%";
            options[i] = {};
            options[i]['value'] = i.toString();
            options[i]['label'] = res[i].title;
          }
          this.form[this.form.length - 1].options = options;
          // 遍历用户可选项
          this.tableData = res;
          this.$nextTick(
            this.loading = false,
          );
        })
        .catch((err) => {
          console.log(err);
          this.$nextTick(
            this.loading = false,
          );
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$refs.date.offsetHeight - 36;
    });
    /*两种01码*/
    bus.$on('tableCode', msg => {
      this.tableCode = msg;
    });
    bus.$on('filedCode', msg => {
      this.filedCode = msg;
    });
    /*设置用户选定的值*/
    bus.$on('sendData', msg => {
      data1.forEach((item, index) => {
        if (msg === item.name) {
          if(item.value !== ''){
            item.value = '';
          }
          this.form.push(item);
        }
      });
      this.disable = true;
      this.getTable();
      this.reload();
    });
  },
  created() {
    this.getHeight();
  }
}
</script>

<style scoped>
  .delDisplay{
    cursor: pointer;
    opacity: 0.2;
  }
  .delDisplay:hover{
    opacity: 1;
  }
/*搜索框样式*/
.userManage {
  width: 100%;
  height: calc(100% - 34px);
}

.userManage .topButton {
  width: 100%;
  height: 50px;
  display: flex;
  background-color: #E9EBEE;
}

.userManage .search {
  height: 100%;
  display: flex;
  align-items: center;
}

.userManage .search .el-button {
  height: 40px;
  margin-left: 30px;
  margin-right: 100%;
}

/*展示框样式*/
.userManage .mainTable1 {
  width: 100%;
  height: calc(100% - 50px);
}

.userManage .el-pagination {
  text-align: center;
}

/*重置默认设置*/
.w {
  margin-left: 0px !important;
}

.userManage .cell>.el-button {
  padding: 7px 5px;
}

/*重置样式*/
.el-dialog__body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

/*查看详情*/
.reset {
  margin-right: 30px;
  line-height: 50px;
  margin-left: 20px;
}
/*图表样式*/
.view{
  line-height: 50px;

}
.data {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.topButton>.el-select {
  margin: 5px 15px 0px 15px;
}

.dataForm {
  display: flex;
  height: 100%;
}

.el-form-item {
  height: 100%;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/statistics/numberStatistics.vue